<header class="h-scrollbar" #stepHeader>
  @for (step of steps; track step; let i = $index) {
  <un-step-title
    #stepTitles
    [index]="i"
    [selected]="step.selected"
    [visited]="step.visited"
    [invalid]="!step.valid"
    [disabled]="!isStepEnabled(i)"
    (click)="setSelectedIndex(i)"
    [unTitle]="step.unTitle"
    [editMode]="editMode"
    [description]="step.description"
    [visitCount]="step.visitCount"
    [id]="step.key || step.unTitle"
    >{{ step.unTitle }}</un-step-title
  >
  }
</header>
<main class="steps-body">
  <ng-content></ng-content>
  <!-- <un-loading *ngIf="isLoading" [overlay]="true"></un-loading> -->
</main>

<footer class="">
  <div class="status-wrapper">
    @if (status) {
    <un-button [type]="status" size="tiny">{{
      status | unTitleCase
    }}</un-button>
    } @if (allowSave) {
    <un-button type="link" (btnClick)="save.emit()" size="small">
      <un-icon type="cloud-upload" theme="outline"></un-icon>
      <span i18n="@@saveAndCountinueLater">Save and continue later</span>
    </un-button>
    }
  </div>
  <div class="extra"></div>
  <div class="navigation">
    @if (!isFirstStep) {
    <un-button size="small" (btnClick)="prevStep()">
      <un-icon type="left" theme="outline"></un-icon>
      <span class="h-sm" i18n="@@prev">Prev:</span>
      <span class="h-sm">{{ steps.get(index - 1)?.unTitle }}</span>
    </un-button>
    } @if (!isLastStep) {
    <un-button size="small" type="primary" (btnClick)="nextStep()">
      <span class="h-sm" i18n="@@next">Next:</span>
      <span class="h-sm">{{ steps.get(index + 1)?.unTitle }}</span>
      <un-icon type="right" theme="outline"></un-icon>
    </un-button>
    } @if (isLastStep) {
    <un-button size="small" type="primary" (btnClick)="submitForm()">
      {{ submitBtnText }}
    </un-button>
    }
  </div>
</footer>
